/* eslint-disable array-callback-return */
import ErrorIcon from '@mui/icons-material/Error';
import { DatePicker, Dropdown, Input, Popover, Space, notification } from 'antd';
import { toast } from 'react-toastify';
import type { DatePickerProps } from 'antd';
import axios from 'axios';
import isMobile from 'is-mobile';
import moment from 'moment';
import { useCallback, useEffect, useRef, useState } from 'react';
import { flushSync } from 'react-dom';
import {
  AddToPlayListModal,
  EditToFuturePlayListModal,
  LoadingSpinner,
  PlayFutureListBanner,
} from '../../components';
import EditAddToPlayListModal from '../../components/AddToPlayListModal/EditAddToPlayListModal';
import PlanToast from '../../components/PlanToast/PlanToast';
import DeleteModal from '../../components/Subscriptions/CancelSubscription';
import { BASE_URL } from '../../constants/api-urls';
import { useLoginContext } from '../../context';
import { usePlaylistContext } from '../../context/PlaylistContext';
import { useScheduledSongs } from '../../context';
import {
  KeyCode,
  addItemToStorage,
  deepEqual,
  getRefreshedToken,
  isEmptyOrNil,
  removeDuplicates,
} from '../../utils';
import { PlaylistStyle1 } from '../Playlist/Playlist.style1';
import { PlaylistStyle, PopoverStyle } from './Playlist.style';
import { FilterIcon } from '../../assets';
import ScheduledPlaylistSongTable from './ScheduledPlaylistSongTable';
import { SPOTIFY_TOKEN } from '../../constants/storage';
import { dateFormate } from '../../utils/utils';
import ShareModal from '../../components/ShareModal/ShareModal';
import InstantShareModal from '../../components/ShareModal/InstantShareModal';
import ShareModalLoader from '../../components/ShareModal/ShareModalLoader';

const ScheduledTracks = () => {
  const { state, dispatch: loginDispatch } = useLoginContext();
  const { state: playlistState } = usePlaylistContext();
  const { setRecentScheduledSongs } = useScheduledSongs();

  const [data, setData] = useState({
    end_time: 'null',
  });
  const [scheduleData, setScheduledItems] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const [pageNo, setpageNo] = useState(1);
  const [limit] = useState(50);
  const [blurBackground, setBlurBackground] = useState(false);

  const [addToPlaylistModal, setAddToPlaylistModal] = useState(false);
  const [EditaddToPlaylistModal, setEditAddToPlaylistModal] = useState(false);
  const [editType, setEditType] = useState('');
  const [loading, setloading] = useState(false);
  const [pageState, setPageState] = useState(1);
  const [existSongUri, setExistSongUri] = useState('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [totalSongs, setTotalSongs] = useState(0);
  const [filterApplied, setFilterApplied] = useState(false);
  const [filterDropDownOpen, setFilterDropDownOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [shareSongModal, setShareSongModal] = useState(false);
  const [shareSongLoaderModal, setShareSongLoaderModal] = useState(false);
  const [instantShareSongModal, setInstantShareSongModal] = useState(false);
  let [once, setOnce] = useState(false);
  const [deleteItem, setDeleteItem] = useState({});
  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const [EditId, setEditId] = useState('');
  const [editObj] = useState({});

  const [selectedSongs, setSelectedSongs] = useState([]);
  const [selectedSongsIds, setSelectedSongsIds] = useState([]);

  const [isModalOpenDeleteSelected, setIsModalOpenDeleteSelected] = useState(false);
  const [PlaylistRefreshRecord, setPlaylistRefreshRecord] = useState([]);
  const [totalPlaylist, setTotalPlaylist] = useState([]);
  const [totalPlaylistNumber, setTotalPlaylistNumber] = useState(0);
  const [playlistDropDownOpen, setPlaylistDropDownOpen] = useState(false);
  const [filterPlayListName, setFilterPlayListName] = useState('Select playlist');
  const [filterPlayListId, setFilterPlayListId] = useState('');
  const [songUri, setSongUri] = useState('');
  const [filterStartDate, setFilterStartDate] = useState('');
  const [filterEndDate, setFilterEndDate] = useState('');
  const [selectedPlayList, setSelectedPlayList] = useState([]);
  const [bulkAction, setBulkAction] = useState(false);

  const [selectedPlayListIds, setSelectedPlayListIds] = useState([]);
  const [searchPlaylistText, setSearchPlaylistText] = useState('');

  const selectedSongsRef = useRef(selectedSongs);
  const selectedSongsIdsRef = useRef(selectedSongsIds);

  const playlistRef = useRef<HTMLElement>();

  const openNotification = () => {
    setBlurBackground(true);
    notification.info({
      message: false,
      description: (
        <div className="NotiDes">
          {' '}
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="10" fill="white" />
            <path
              d="M12 13C12.2833 13 12.521 12.904 12.713 12.712C12.9043 12.5207 13 12.2833 13 12V7.975C13 7.69167 12.9043 7.45833 12.713 7.275C12.521 7.09167 12.2833 7 12 7C11.7167 7 11.4793 7.09567 11.288 7.287C11.096 7.479 11 7.71667 11 8V12.025C11 12.3083 11.096 12.5417 11.288 12.725C11.4793 12.9083 11.7167 13 12 13ZM12 17C12.2833 17 12.521 16.904 12.713 16.712C12.9043 16.5207 13 16.2833 13 16C13 15.7167 12.9043 15.479 12.713 15.287C12.521 15.0957 12.2833 15 12 15C11.7167 15 11.4793 15.0957 11.288 15.287C11.096 15.479 11 15.7167 11 16C11 16.2833 11.096 16.5207 11.288 16.712C11.4793 16.904 11.7167 17 12 17ZM12 22C10.6167 22 9.31667 21.7373 8.1 21.212C6.88333 20.6873 5.825 19.975 4.925 19.075C4.025 18.175 3.31267 17.1167 2.788 15.9C2.26267 14.6833 2 13.3833 2 12C2 10.6167 2.26267 9.31667 2.788 8.1C3.31267 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.31233 8.1 2.787C9.31667 2.26233 10.6167 2 12 2C13.3833 2 14.6833 2.26233 15.9 2.787C17.1167 3.31233 18.175 4.025 19.075 4.925C19.975 5.825 20.6873 6.88333 21.212 8.1C21.7373 9.31667 22 10.6167 22 12C22 13.3833 21.7373 14.6833 21.212 15.9C20.6873 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6873 15.9 21.212C14.6833 21.7373 13.3833 22 12 22Z"
              fill="#007AFF"
            />
          </svg>
          Song has been successfully added.
        </div>
      ),
      placement: 'top',
      onClose() {
        setBlurBackground(false);
      },
      style: {
        background: 'rgb(28, 22, 54)',
        border: '2px solid #007AFF',
        borderRadius: '8px',
        padding: '9px 16px',
        color: 'white',
      },
      closeIcon: (
        <svg
          width="14"
          height="16"
          viewBox="0 0 14 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.86858 8L11.9701 3.11094C12.0389 3.02969 11.9811 2.90625 11.8748 2.90625H10.628C10.5545 2.90625 10.4842 2.93906 10.4358 2.99531L7.05296 7.02813L3.67014 2.99531C3.62327 2.93906 3.55296 2.90625 3.47796 2.90625H2.23108C2.12483 2.90625 2.06702 3.02969 2.13577 3.11094L6.23733 8L2.13577 12.8891C2.12037 12.9072 2.11049 12.9293 2.1073 12.9529C2.10412 12.9764 2.10776 13.0004 2.11779 13.022C2.12783 13.0435 2.14383 13.0617 2.16392 13.0745C2.184 13.0872 2.20731 13.0939 2.23108 13.0938H3.47796C3.55139 13.0938 3.62171 13.0609 3.67014 13.0047L7.05296 8.97188L10.4358 13.0047C10.4826 13.0609 10.553 13.0938 10.628 13.0938H11.8748C11.9811 13.0938 12.0389 12.9703 11.9701 12.8891L7.86858 8Z"
            fill="white"
          />
        </svg>
      ),
    });
  };

  const getFuturelist = (page, filter) => {
    setloading(true);
    setOnce(true);
    if (filter && page === 1) {
      setPageState(1);
      setpageNo(1);
      if (isEmptyOrNil(state.token)) return;
      if (isEmptyOrNil(state.userId)) return;
      axios(
        `${process.env.REACT_APP_BACKEND_URI}/filtersInPlaylist/?${
          filter.playlsitId
            ? `playlist_id=${filter.playlsitId}${
                filter.songUri || filter.start_date || filter.end_date ? '&' : ''
              }`
            : ''
        }${
          filter.songUri
            ? `song_uri=${filter.songUri}${filter.start_date || filter.end_date ? '&' : ''}`
            : ''
        }${
          filter.start_date ? `start_date=${filter.start_date}${filter.end_date ? '&' : ''}` : ''
        }${filter.end_date ? `end_date=${filter.end_date}` : ''}${
          state.userId ? `&userId=${state.userId}` : ''
        }&preRelease=0&scheduleSong=1&access_token=${state.token}`,
        {
          method: 'GET',
          headers: { Authorization: 'Bearer ' + state.token },
        }
      )
        .then(genreResponse => {
          setScheduledItems(genreResponse.data.data);
          setTotalSongs(genreResponse.data.total);
          let start = page === 1 ? 0 : (page - 1) * limit;
          let end = page === 1 ? limit : page * limit;
          let data = genreResponse.data.data.slice(start, end);
          setPaginatedData(data);
          setloading(false);
        })
        .catch(async error => {
          setloading(false);
          setOnce(false);
          if (error.response?.data?.error?.status === 401 || error.response?.status === 400) {
            getRefreshedToken(state.refreshToken)
              .then(response => {
                addItemToStorage(SPOTIFY_TOKEN, response?.data?.access_token);

                loginDispatch({
                  type: 'ADD_TOKEN',
                  payload: response?.data?.access_token,
                });
              })
              .catch(() => {});
          }
        });
    } else if (!page) {
      setPageState(page);
      if (isEmptyOrNil(state.token)) return;
      axios(
        `${process.env.REACT_APP_BACKEND_URI}/GetScheduledList/?page=${page}&limit=10&access_token=${state.token}&userId=${state.userId}`,
        {
          method: 'GET',
          headers: { Authorization: 'Bearer ' + state.token },
        }
      )
        .then(genreResponse => {
          setScheduledItems(genreResponse.data.data);
          setTotalSongs(genreResponse.data.total);
          let start = pageNo === 1 ? 0 : (pageNo - 1) * limit;
          let end = pageNo === 1 ? limit : pageNo * limit;
          let data = genreResponse.data.data.slice(start, end);
          setPaginatedData(data);
          setloading(false);
          openInstantShareModal();
        })
        .catch(async error => {
          setloading(false);
          setOnce(false);
          if (error.response?.data?.error?.status === 401 || error.response?.status === 400) {
            getRefreshedToken(state.refreshToken)
              .then(response => {
                addItemToStorage(SPOTIFY_TOKEN, response?.data?.access_token);

                loginDispatch({
                  type: 'ADD_TOKEN',
                  payload: response?.data?.access_token,
                });
              })
              .catch(() => {});
          }
        });
    } else {
      setpageNo(page);
      let start = page === 1 ? 0 : (page - 1) * limit;
      let end = page === 1 ? limit : page * limit;
      let data = scheduleData.slice(start, end);
      setPaginatedData(data);
      setloading(false);
    }
  };
  useEffect(() => {
    if (state.userId) {
      if (!once) {
        getFuturelist(0, false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, once]);

  // Update the context whenever scheduleData changes
  useEffect(() => {
    if (Array.isArray(scheduleData) && scheduleData.length > 0) {
      setRecentScheduledSongs(scheduleData);
    }
  }, [scheduleData, setRecentScheduledSongs]);

  // Optimistic update callback for end date changes
  const updateSongEndDate = useCallback(
    (songUri: string, newEndDate: string, songId: string) => {
      // Use flushSync to force immediate, synchronous UI update
      // IMPORTANT: Use songId (_id) to identify the specific song entry
      flushSync(() => {
        setScheduledItems(prev => {
          const songExists = prev.some(item => item._id === songId);

          if (songExists) {
            // Update existing song by _id (unique identifier)
            const updated = prev.map(item =>
              item._id === songId
                ? { ...item, localData: { ...item.localData, end_time: newEndDate } }
                : item
            );

            // Also update paginated data
            let start = pageNo === 1 ? 0 : (pageNo - 1) * limit;
            let end = pageNo === 1 ? limit : pageNo * limit;
            let paginatedSlice = updated.slice(start, end);
            setPaginatedData(paginatedSlice);

            return updated;
          }

          return prev;
        });
      });
    },
    [pageNo, limit]
  );

  // Optimistic update callback for notes changes
  const updateSongNotes = useCallback(
    (songUri: string, newNotes: string, songId: string) => {
      // Use flushSync to force immediate, synchronous UI update
      // IMPORTANT: Use songId (_id) to identify the specific song entry
      flushSync(() => {
        setScheduledItems(prev => {
          const songExists = prev.some(item => item._id === songId);

          if (songExists) {
            // Update existing song by _id (unique identifier)
            // Update BOTH localData.notes AND root notes to handle different data structures
            const updated = prev.map(item =>
              item._id === songId
                ? {
                    ...item,
                    notes: newNotes,
                    localData: { ...item.localData, notes: newNotes },
                  }
                : item
            );

            // Also update paginated data
            let start = pageNo === 1 ? 0 : (pageNo - 1) * limit;
            let end = pageNo === 1 ? limit : pageNo * limit;
            let paginatedSlice = updated.slice(start, end);
            setPaginatedData(paginatedSlice);

            return updated;
          }

          return prev;
        });
      });
    },
    [pageNo, limit]
  );

  const deleteSongFromDb = async (row: any) => {
    if (row?._id) {
      // Get Auth0 user ID and profile info from localStorage
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      const spotifyUser = JSON.parse(localStorage.getItem('spotifyUser') || '{}');
      const auth0UserId = userInfo?.userId || '';

      // If on shared profile, use owner's profile ObjectId, otherwise use accessor's Auth0 ID
      const profileIdentifier =
        spotifyUser.isShared === true && spotifyUser.profileId
          ? spotifyUser.profileId // Owner's profile ObjectId for shared profiles
          : auth0UserId; // Accessor's Auth0 ID for own profiles

      const config = {
        song_uri: row.uri,
        selected_playlist_Id: row.selected_playlist_id,
        _id: row?._id,
        userId: auth0UserId, // Accessor's Auth0 ID for access validation
        profileId: profileIdentifier, // Profile identifier (ObjectId for shared, Auth0 ID for own)
        headers: {
          'Content-Type': 'application-json',
        },
      };
      await axios
        .post(`${BASE_URL}/DeleteSongfromPlaylist/delete`, config)
        .then(() => {
          toast.success('The track has been deleted successfully');

          // SUCCESS: Update local state instead of reload
          flushSync(() => {
            setScheduledItems(prev => {
              const updated = prev.filter(item => item._id !== row._id);

              // Also update paginated data
              let start = pageNo === 1 ? 0 : (pageNo - 1) * limit;
              let end = pageNo === 1 ? limit : pageNo * limit;
              let paginatedSlice = updated.slice(start, end);
              setPaginatedData(paginatedSlice);

              return updated;
            });
          });

          setloading(false);
        })
        .catch(err => {
          toast.error('Failed to delete song');
          setloading(false);
        });
    }
  };

  const handleRowDelete = async (row: any) => {
    let obj = {
      items: [
        {
          uri: row.uri,
        },
      ],
    };
    axios
      .delete(`https://api.spotify.com/v1/playlists/${row.selected_playlist_id}/items`, {
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
        data: JSON.stringify(obj),
      })
      .then(async delatedSongDetails => {
        deleteSongFromDb(row);
      })
      .catch(b => {
        deleteSongFromDb(row);
      });
  };

  useEffect(() => {
    if (!addToPlaylistModal) {
      setExistSongUri('');
    }
  }, [addToPlaylistModal]);

  let playdata = [];
  let play = '';
  const total = Array.isArray(scheduleData) ? scheduleData.length : 0;
  if (Array.isArray(scheduleData)) {
    scheduleData.map((e, index) => {
      // Use totalPlaylist if available (has all playlists), otherwise fall back to playlistState
      const playlistsToSearch = totalPlaylist.length > 0 ? totalPlaylist : playlistState?.playlists;
      const currentPlaylistContent = Array.isArray(playlistsToSearch)
        ? playlistsToSearch.find(item => {
            if (e) {
              // Check both localData and root level for playlist ID
              const playlistId = e?.localData?.selected_playlist_id || e?.selected_playlist_id;
              if (playlistId) {
                return item?.id === playlistId;
              }
            }
            return false;
          })
        : undefined;
      if (currentPlaylistContent) {
        play = currentPlaylistContent.name;
      }
      if (isMobile() === true) {
        playdata.push({
          key: (
            <PopoverStyle>
              <p style={{ marginLeft: '10px' }}>
                {e.working ? (
                  <Popover placement="right" content={e.working ? <p>{e.working}</p> : ''}>
                    <ErrorIcon style={{ color: 'orange', marginLeft: '-5px' }} />
                  </Popover>
                ) : (
                  index + 1
                )}
              </p>
            </PopoverStyle>
          ),
          image: './static/background.png',
          name: (
            <PopoverStyle>
              <Popover
                content={
                  <>
                    <div style={{ padding: '5px' }}>
                      <p style={{ fontSize: '11px' }}>Start Time</p>
                      <p>
                        {moment(e.start_time).format('DD-MM-YYYY hh:mm A') !== 'Invalid date'
                          ? moment(e.start_time).format('llll')
                          : '-'}
                      </p>
                    </div>
                    <div style={{ padding: '5px' }}>
                      <p style={{ fontSize: '11px' }}>End time</p>
                      <p>
                        {e.end_time &&
                        moment(e.end_time).format('DD-MM-YYYY hh:mm A') !== 'Invalid date'
                          ? moment(e.end_time).format('llll')
                          : '-'}
                      </p>
                    </div>
                    <div style={{ padding: '5px' }}>
                      <p style={{ fontSize: '11px' }}>Playlist</p>
                      <p>{play}</p>
                    </div>
                  </>
                }
                title="Extra Info"
                trigger="click"
              >
                <p>{e.song_uri}</p>
              </Popover>
            </PopoverStyle>
          ),

          Edit: (
            <EditToFuturePlayListModal
              setSongUri={e.song_uri}
              setStartTime={e.start_time}
              setEndTime={e.end_time}
              setPlaylist={e.selected_playlist_id}
              setPosition={e.position}
              setPlayId={e._id}
            />
          ),
        });
      } else {
        playdata.push({
          key: (
            <PopoverStyle>
              <p style={{ marginLeft: '10px' }}>
                {e.working ? (
                  <Popover placement="right" content={e.working ? <p>{e.working}</p> : ''}>
                    <ErrorIcon style={{ color: 'orange', marginLeft: '-5px' }} />
                  </Popover>
                ) : (
                  index + 1
                )}
              </p>
            </PopoverStyle>
          ),

          image: './static/background.png',
          name: (
            <>
              <p>{e.song_uri}</p>
            </>
          ),
          startTime:
            moment(e.start_time).format('DD-MM-YYYY hh:mm A') !== 'Invalid date'
              ? moment(e.start_time).format('llll')
              : '-',
          endTime:
            e.end_time && moment(e.end_time).format('DD-MM-YYYY hh:mm A') !== 'Invalid date'
              ? moment(e.end_time).format('llll')
              : '-',
          previewUrl: e.song_uri,
          artist: play,

          Edit: (
            <EditToFuturePlayListModal
              setSongUri={e.song_uri}
              setStartTime={e.start_time}
              setEndTime={e.end_time}
              setPlaylist={e.selected_playlist_id}
              setPosition={e.position}
              setPlayId={e._id}
            />
          ),
        });
      }
    });
  }

  const showModalDelete = id => {
    setIsModalOpenDelete(true);
  };

  const handleOkDelete = () => {
    handleRowDelete(deleteItem);
    setDeleteItem({});
    setIsModalOpenDelete(false);
  };

  const handleCancelDelete = () => {
    setDeleteItem({});
    setIsModalOpenDelete(false);
  };

  // Update the ref whenever selectedSongs changes
  useEffect(() => {
    selectedSongsRef.current = selectedSongs;
  }, [selectedSongs]);

  // Update the ref whenever selectedSongs changes
  useEffect(() => {
    selectedSongsIdsRef.current = selectedSongsIds;
  }, [selectedSongsIds]);

  const handleItemDeleteSelected = () => {
    // Get Auth0 user ID and profile info from localStorage
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    const spotifyUser = JSON.parse(localStorage.getItem('spotifyUser') || '{}');
    const auth0UserId = userInfo?.userId || state.userId || '';

    // If on shared profile, use owner's profile ObjectId, otherwise use accessor's Auth0 ID
    const profileIdentifier =
      spotifyUser.isShared === true && spotifyUser.profileId
        ? spotifyUser.profileId // Owner's profile ObjectId for shared profiles
        : auth0UserId; // Accessor's Auth0 ID for own profiles

    const config = {
      ids: selectedSongsIdsRef.current,
      userId: auth0UserId, // Accessor's Auth0 ID for access validation
      profileId: profileIdentifier, // Profile identifier (ObjectId for shared, Auth0 ID for own)
      headers: {
        'Content-Type': 'application-json',
      },
    };

    selectedSongsRef.current?.map((a, i) => {
      let obj = {
        items: [
          {
            uri: a.uri,
          },
        ],
      };
      axios
        .delete(`https://api.spotify.com/v1/playlists/${a.playlistId}/items`, {
          headers: {
            Authorization: `Bearer ${state.token}`,
          },
          data: JSON.stringify(obj),
        })
        .then(async delatedSongDetails => {
          if (i === selectedSongsRef.current?.length - 1) {
            axios
              .post(`${BASE_URL}/deleteMultipleSongs`, config)
              .then(() => {
                // SUCCESS: Update local state instead of reload
                const deletedIds = selectedSongsIdsRef.current;

                flushSync(() => {
                  setScheduledItems(prev => {
                    const updated = prev.filter(item => !deletedIds.includes(item._id));

                    // Also update paginated data
                    let start = pageNo === 1 ? 0 : (pageNo - 1) * limit;
                    let end = pageNo === 1 ? limit : pageNo * limit;
                    let paginatedSlice = updated.slice(start, end);
                    setPaginatedData(paginatedSlice);

                    return updated;
                  });
                });

                // Clear selections
                setSelectedSongs([]);
                setSelectedSongsIds([]);

                toast.success(`${deletedIds.length} song(s) deleted successfully`);
              })
              .catch(err => {
                toast.error('Failed to delete songs');
              });
          }
        })
        .catch(err => {
          toast.error('Failed to delete song from Spotify');
        });
    });
  };
  const showModalDeleteSelected = () => {
    setIsModalOpenDeleteSelected(true);
  };

  const handleOkDeleteSelected = () => {
    setIsModalOpenDeleteSelected(false);
    //@ts-ignore
    handleItemDeleteSelected();
  };

  const handleCancelDeleteSelected = () => {
    setIsModalOpenDeleteSelected(false);
  };

  useEffect(() => {
    if (selectedSongs?.length) {
      const handleKeyDown = ev => {
        let show = localStorage.getItem('dontShow');

        if (ev.keyCode === KeyCode('delete')) {
          if (
            !isModalOpenDelete &&
            !shareSongLoaderModal &&
            !instantShareSongModal &&
            !shareSongModal &&
            !EditaddToPlaylistModal &&
            !addToPlaylistModal
          ) {
            if (show === 'true') {
              handleItemDeleteSelected();
            } else {
              showModalDeleteSelected();
            }
          }
        } else if (ev.keyCode === KeyCode('esc')) {
          setSelectedSongs([]);
          setSelectedSongsIds([]);
        }
      };
      window.addEventListener('keydown', handleKeyDown);
      return () => {
        window.removeEventListener('keydown', handleKeyDown);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedSongs,
    isModalOpenDelete,
    shareSongLoaderModal,
    instantShareSongModal,
    shareSongModal,
    EditaddToPlaylistModal,
    addToPlaylistModal,
  ]);

  const getPlaylistRefreshRecord = async obj => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const { data } = await axios.get(
      `${BASE_URL}/PlaylistRefreshRecord/${obj.localData.selected_playlist_id}/data`,
      config
    );
    setPlaylistRefreshRecord(data.data);
    setShareSongLoaderModal(false);
    setShareSongModal(true);
    setData(obj);
  };
  const menu = (id, obj) => (
    <PlaylistStyle1>
      <div style={{ position: 'relative' }}>
        <PlanToast available={['pro', 'unlimited']} titleHeading={'Edit end date'}>
          <div
            className="playListMenu"
            onClick={() => {
              setEditType('editDate');
              setEditAddToPlaylistModal(true);
              setEditId(id);
              setData(obj);
            }}
          >
            <div className="playListMenuSvg">
              <svg
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188ZM5.71465 10.6531L12.0902 4.2793L13.3787 5.56777L7.00312 11.9416L5.44043 12.2176L5.71465 10.6531ZM15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953Z"
                  fill="white"
                />
              </svg>
            </div>
            <p className="playListMenuText">Edit end date</p>
          </div>
        </PlanToast>
      </div>
      <div className="playListMenu">
        <div className="playListMenuSvg">
          <svg
            width="15"
            height="15"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.1666 3.5L7.66658 1M7.66658 1L5.16658 3.5M7.66658 1V9.33334M11.8331 6.83334C12.6096 6.83334 12.9979 6.83334 13.3042 6.96017C13.7126 7.12934 14.0372 7.45401 14.2064 7.86242C14.3333 8.16867 14.3333 8.55676 14.3333 9.33334V13.3333C14.3333 14.2668 14.3333 14.7332 14.1516 15.0897C13.9918 15.4033 13.737 15.6588 13.4234 15.8185C13.0673 16 12.6008 16 11.6692 16H3.66358C2.73199 16 2.26616 16 1.90999 15.8185C1.59641 15.6588 1.34116 15.4033 1.18141 15.0897C0.999908 14.7335 0.999908 14.2675 0.999908 13.3359V9.33334C0.999908 8.55676 0.999991 8.16867 1.12682 7.86242C1.29599 7.45401 1.62041 7.12934 2.02874 6.96017C2.33508 6.83334 2.72333 6.83334 3.49991 6.83334"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <p
          className="playListMenuText"
          onClick={() => {
            getPlaylistRefreshRecord(obj);
            setShareSongLoaderModal(true);
          }}
        >
          Share song details
        </p>
      </div>
      <div
        className="playListMenu"
        onClick={() => {
          setEditType('addNote');
          setEditAddToPlaylistModal(true);
          setEditId(id);
          setData(obj);
        }}
      >
        <div className="playListMenuSvg">
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 10.5H6C5.80109 10.5 5.61032 10.579 5.46967 10.7197C5.32902 10.8603 5.25 11.0511 5.25 11.25C5.25 11.4489 5.32902 11.6397 5.46967 11.7803C5.61032 11.921 5.80109 12 6 12H12C12.1989 12 12.3897 11.921 12.5303 11.7803C12.671 11.6397 12.75 11.4489 12.75 11.25C12.75 11.0511 12.671 10.8603 12.5303 10.7197C12.3897 10.579 12.1989 10.5 12 10.5ZM12 7.5H7.5C7.30109 7.5 7.11032 7.57902 6.96967 7.71967C6.82902 7.86032 6.75 8.05109 6.75 8.25C6.75 8.44891 6.82902 8.63968 6.96967 8.78033C7.11032 8.92098 7.30109 9 7.5 9H12C12.1989 9 12.3897 8.92098 12.5303 8.78033C12.671 8.63968 12.75 8.44891 12.75 8.25C12.75 8.05109 12.671 7.86032 12.5303 7.71967C12.3897 7.57902 12.1989 7.5 12 7.5ZM15 3H12.75V2.25C12.75 2.05109 12.671 1.86032 12.5303 1.71967C12.3897 1.57902 12.1989 1.5 12 1.5C11.8011 1.5 11.6103 1.57902 11.4697 1.71967C11.329 1.86032 11.25 2.05109 11.25 2.25V3H9.75V2.25C9.75 2.05109 9.67098 1.86032 9.53033 1.71967C9.38968 1.57902 9.19891 1.5 9 1.5C8.80109 1.5 8.61032 1.57902 8.46967 1.71967C8.32902 1.86032 8.25 2.05109 8.25 2.25V3H6.75V2.25C6.75 2.05109 6.67098 1.86032 6.53033 1.71967C6.38968 1.57902 6.19891 1.5 6 1.5C5.80109 1.5 5.61032 1.57902 5.46967 1.71967C5.32902 1.86032 5.25 2.05109 5.25 2.25V3H3C2.80109 3 2.61032 3.07902 2.46967 3.21967C2.32902 3.36032 2.25 3.55109 2.25 3.75V14.25C2.25 14.8467 2.48705 15.419 2.90901 15.841C3.33097 16.2629 3.90326 16.5 4.5 16.5H13.5C14.0967 16.5 14.669 16.2629 15.091 15.841C15.5129 15.419 15.75 14.8467 15.75 14.25V3.75C15.75 3.55109 15.671 3.36032 15.5303 3.21967C15.3897 3.07902 15.1989 3 15 3ZM14.25 14.25C14.25 14.4489 14.171 14.6397 14.0303 14.7803C13.8897 14.921 13.6989 15 13.5 15H4.5C4.30109 15 4.11032 14.921 3.96967 14.7803C3.82902 14.6397 3.75 14.4489 3.75 14.25V4.5H5.25V5.25C5.25 5.44891 5.32902 5.63968 5.46967 5.78033C5.61032 5.92098 5.80109 6 6 6C6.19891 6 6.38968 5.92098 6.53033 5.78033C6.67098 5.63968 6.75 5.44891 6.75 5.25V4.5H8.25V5.25C8.25 5.44891 8.32902 5.63968 8.46967 5.78033C8.61032 5.92098 8.80109 6 9 6C9.19891 6 9.38968 5.92098 9.53033 5.78033C9.67098 5.63968 9.75 5.44891 9.75 5.25V4.5H11.25V5.25C11.25 5.44891 11.329 5.63968 11.4697 5.78033C11.6103 5.92098 11.8011 6 12 6C12.1989 6 12.3897 5.92098 12.5303 5.78033C12.671 5.63968 12.75 5.44891 12.75 5.25V4.5H14.25V14.25Z"
              fill="white"
            />
          </svg>
        </div>
        <p className="playListMenuText">{obj?.notes ? 'Edit' : 'Add'} notes</p>
      </div>

      <div
        className="playListMenu"
        onClick={() => {
          setEditType('delete');
          showModalDelete(id);
          setDeleteItem(obj);
        }}
      >
        <div className="playListMenuSvg">
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.875 3.375H10.125C10.125 3.07663 10.0065 2.79048 9.7955 2.5795C9.58452 2.36853 9.29837 2.25 9 2.25C8.70163 2.25 8.41548 2.36853 8.2045 2.5795C7.99353 2.79048 7.875 3.07663 7.875 3.375ZM6.75 3.375C6.75 2.77826 6.98705 2.20597 7.40901 1.78401C7.83097 1.36205 8.40326 1.125 9 1.125C9.59674 1.125 10.169 1.36205 10.591 1.78401C11.0129 2.20597 11.25 2.77826 11.25 3.375H15.75C15.8992 3.375 16.0423 3.43426 16.1477 3.53975C16.2532 3.64524 16.3125 3.78832 16.3125 3.9375C16.3125 4.08668 16.2532 4.22976 16.1477 4.33525C16.0423 4.44074 15.8992 4.5 15.75 4.5H15.1155L13.7599 14.4427C13.6679 15.1165 13.335 15.7342 12.8226 16.1814C12.3103 16.6286 11.6533 16.875 10.9732 16.875H7.02675C6.34671 16.875 5.6897 16.6286 5.17736 16.1814C4.66503 15.7342 4.33207 15.1165 4.24013 14.4427L2.8845 4.5H2.25C2.10082 4.5 1.95774 4.44074 1.85225 4.33525C1.74676 4.22976 1.6875 4.08668 1.6875 3.9375C1.6875 3.78832 1.74676 3.64524 1.85225 3.53975C1.95774 3.43426 2.10082 3.375 2.25 3.375H6.75ZM7.875 7.3125C7.875 7.16332 7.81574 7.02024 7.71025 6.91475C7.60476 6.80926 7.46168 6.75 7.3125 6.75C7.16332 6.75 7.02024 6.80926 6.91475 6.91475C6.80926 7.02024 6.75 7.16332 6.75 7.3125V12.9375C6.75 13.0867 6.80926 13.2298 6.91475 13.3352C7.02024 13.4407 7.16332 13.5 7.3125 13.5C7.46168 13.5 7.60476 13.4407 7.71025 13.3352C7.81574 13.2298 7.875 13.0867 7.875 12.9375V7.3125ZM10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125V12.9375C11.25 13.0867 11.1907 13.2298 11.0852 13.3352C10.9798 13.4407 10.8367 13.5 10.6875 13.5C10.5383 13.5 10.3952 13.4407 10.2898 13.3352C10.1843 13.2298 10.125 13.0867 10.125 12.9375V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75ZM5.355 14.2909C5.41021 14.6951 5.60998 15.0656 5.91732 15.3338C6.22467 15.6021 6.6188 15.7499 7.02675 15.75H10.9732C11.3814 15.7502 11.7758 15.6025 12.0834 15.3342C12.391 15.0659 12.5909 14.6953 12.6461 14.2909L13.9804 4.5H4.01962L5.355 14.2909Z"
              fill="white"
            />
          </svg>
        </div>
        <p className="playListMenuText">Delete this song</p>
      </div>
    </PlaylistStyle1>
  );

  const getPlaylistItems = playlists => {
    const playlist = [];
    if (!Array.isArray(playlists)) return playlist;
    playlists.map(data => {
      const spotifyUser = JSON.parse(localStorage.getItem('spotifyUser'));
      if (data?.owner?.display_name === spotifyUser?.username) {
        playlist.push({
          key: data.id,
          value: data.name,
        });
      }
    });
    return playlist;
  };
  const getPlaylists = offset => {
    axios(`https://api.spotify.com/v1/me/playlists?limit=50&offset=${offset}`, {
      method: 'GET',
      headers: { Authorization: 'Bearer ' + state.token },
    })
      .then(genreResponse => {
        setTotalPlaylist([...totalPlaylist, ...genreResponse?.data.items]);
        if (totalPlaylistNumber < genreResponse?.data.total) {
          setTotalPlaylistNumber(genreResponse?.data.total);
        }
      })
      .catch(async error => {
        if (error.response?.data?.error?.status === 401 || error.response?.status === 400) {
          getRefreshedToken(state.refreshToken)
            .then(response => {
              addItemToStorage(SPOTIFY_TOKEN, response?.data?.access_token);

              loginDispatch({
                type: 'ADD_TOKEN',
                payload: response?.data?.access_token,
              });
            })
            .catch(() => {});
        }
      });
  };
  useEffect(() => {
    // Load all playlists on mount and when filter dropdown opens
    if (totalPlaylist.length < totalPlaylistNumber || totalPlaylist.length === 0) {
      getPlaylists(totalPlaylist.length);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterDropDownOpen, totalPlaylistNumber, totalPlaylist]);
  const onChangefilterStartDate: DatePickerProps['onChange'] = (date, dateString) => {
    setFilterStartDate(new Date(dateString).toString());
  };
  const onChangefilterEndDate: DatePickerProps['onChange'] = (date, dateString) => {
    setFilterEndDate(new Date(dateString).toString());
  };

  const openInstantShareModal = () => {
    let instantShareDetail = JSON.parse(localStorage.getItem('instantShareDetail'));
    if (instantShareDetail) {
      setInstantShareSongModal(true);
    }
  };
  const filterDropDown = () => {
    return (
      <div
        className="dropdownFilter"
        id="dropdownFilter"
        onClick={() => {
          setPlaylistDropDownOpen(false);
        }}
      >
        <div className="inputDiv">
          <p className="inputLabel">Search playlist</p>
          <div
            className="filterSelect"
            onClick={e => {
              e.stopPropagation();
              setPlaylistDropDownOpen(!playlistDropDownOpen);
            }}
          >
            <div className="playlistValue playlistInputText ">
              {selectedPlayList.map((a, i) => (
                <span>{a}</span>
              ))}
              <input
                className="playlistInputTextSearch"
                style={{
                  border: 'none',
                  background: 'transparent',
                  outline: 'none',
                  color: 'white',
                }}
                placeholder="Search playlist"
                value={searchPlaylistText}
                onChange={ev => {
                  setSearchPlaylistText(ev.target.value);
                }}
              />
            </div>
            <div className={`filterDropDownMenuSelect ${playlistDropDownOpen ? 'active' : ''}`}>
              {Array.isArray(totalPlaylist) &&
                getPlaylistItems(totalPlaylist).map((a, i) => {
                  return a.value.includes(searchPlaylistText) ? (
                    <div
                      className={`optionName ${filterPlayListName === a.value ? 'active' : ''}`}
                      onClick={value => {
                        value.stopPropagation();
                        let playlistids = [...selectedPlayListIds];
                        if (playlistids.includes(a.key)) {
                          playlistids.splice(playlistids.indexOf(a.key), 1);
                          // @ts-ignore
                          setSelectedPlayListIds(playlistids);
                          let playlist = [...selectedPlayList];
                          playlist.splice(playlist.indexOf(a.value), 1);
                          setSelectedPlayList([...playlist]);
                        } else {
                          // @ts-ignore
                          playlistids = [...playlistids, a.key];
                          setSelectedPlayListIds(playlistids);

                          let playlist = [...selectedPlayList];
                          playlist = [...playlist, a.value];
                          setSelectedPlayList([...playlist]);
                        }
                        setSearchPlaylistText('');
                      }}
                    >
                      <div className="optionText">
                        <p>{a.value}</p>
                        <div
                          className={`optionMark ${
                            selectedPlayListIds.includes(a.key) ? 'active' : ''
                          }`}
                        >
                          <svg
                            width="13"
                            height="10"
                            viewBox="0 0 13 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.5 5.5L5 9L12 1.5"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  ) : null;
                })}
            </div>
          </div>
        </div>
        <div className="inputDiv">
          <p className="inputLabel">Enter URI/ URL</p>
          <Input
            placeholder="Enter URI/URL"
            onChange={ev => {
              setSongUri(ev.target.value);
            }}
          />
        </div>
        <div className="inputDiv">
          <p className="inputLabel">By start date</p>
          <DatePicker
            value={filterStartDate ? moment(filterStartDate) : null}
            className="datePickerFilter"
            popupClassName="datePickerFilterPopup"
            onChange={onChangefilterStartDate}
          />
        </div>
        <div className="inputDiv">
          <p className="inputLabel">By end date</p>
          <DatePicker
            value={filterEndDate ? moment(filterEndDate) : null}
            className="datePickerFilter"
            popupClassName="datePickerFilterPopup"
            onChange={onChangefilterEndDate}
          />
        </div>

        <div className="applyFilterButtonDiv">
          <button
            className="applyFilterButton"
            onClick={() => {
              setFilterApplied(true);
              setFilterDropDownOpen(false);
              setFilterPlayListId(selectedPlayList.join(', '));
              setFilterPlayListName(selectedPlayList.join(', '));
              setSearchPlaylistText('');
              setPageState(1);
              setpageNo(1);
              getFuturelist(1, {
                playlsitId: selectedPlayListIds.join(','),
                songUri: songUri,
                start_date: filterStartDate,
                end_date: filterEndDate,
              });
            }}
          >
            Apply filters
          </button>
          <button
            className="resetFilterButton"
            onClick={() => {
              setFilterApplied(false);
              setFilterDropDownOpen(false);
              getFuturelist(0, false);
              setFilterPlayListId('');
              setFilterPlayListName('Select playlist');
              setFilterStartDate('');
              setSearchPlaylistText('');
              setFilterEndDate('');
              setPageState(1);
              setpageNo(1);
              setSelectedPlayListIds([]);
              setSelectedPlayList([]);
            }}
          >
            Clear filters
          </button>
        </div>
      </div>
    );
  };

  const selectSongFunction = (obj, id, i) => {
    let arr = [...selectedSongs];
    if (arr.some(item => deepEqual(item, obj))) {
      let index = arr.findIndex(item => deepEqual(item, obj));
      arr.splice(index, 1);
      if (arr.length) {
        setSelectedIndex(i);
        setSelectedSongs(arr);
      } else {
        setSelectedIndex(0);
        setSelectedSongs([]);
      }
    } else {
      setSelectedIndex(i);
      arr.push(obj);
      setSelectedSongs(arr);
    }
    let idsArr = [...selectedSongsIds];
    if (idsArr.some(item => deepEqual(item, obj))) {
      let index = idsArr.findIndex(item => deepEqual(item, obj));
      idsArr.splice(index, 1);
      setSelectedSongsIds(idsArr);
    } else {
      if (id) {
        idsArr.push(id);
      }
      setSelectedSongsIds(idsArr);
    }
  };

  const selectMultpleSongFunction = (arrSelected, id) => {
    let arr = [...selectedSongs];
    arrSelected.map((a, i) => {
      if (!arr.some(item => deepEqual(item, a))) {
        arr.push(a);
      }
    });
    setSelectedSongs(removeDuplicates(arr));
    let idsArr = [...selectedSongsIds];
    id.map((a, i) => {
      if (!idsArr.some(item => deepEqual(item, a))) {
        idsArr.push(a);
      }
    });
    setSelectedSongsIds(removeDuplicates(idsArr));
  };
  const selectSingleSong = (obj, id, i) => {
    let arr = selectedSongs;
    if (arr.some(item => deepEqual(item, obj))) {
      let index = arr.findIndex(item => deepEqual(item, obj));
      arr.splice(index, 1);
      if (arr.length) {
        setSelectedIndex(i);
        setSelectedSongs(arr);
      } else {
        setSelectedIndex(0);
        setSelectedSongs([]);
      }
    } else {
      setSelectedIndex(i);
      arr = [obj];
      setSelectedSongs(arr);
    }
    let idsArr = selectedSongsIds;
    if (idsArr.some(item => deepEqual(item, obj))) {
      let index = idsArr.findIndex(item => deepEqual(item, obj));
      idsArr.splice(index, 1);
      setSelectedSongsIds(idsArr);
    } else {
      if (id) {
        idsArr = [id];
      }
      setSelectedSongsIds(idsArr);
    }
  };

  return (
    <PlaylistStyle ref={playlistRef} className="schedule-song-page">
      <PlayFutureListBanner
        title={'Scheduled tracks'}
        totalSongs={`${total} songs`}
        desc={''}
        image={'/background1.png'}
        openNotification={openNotification}
        setAddToPlaylistModal={setAddToPlaylistModal}
        pageName={'scheduled_tracks'}
      />

      {loading ? (
        <div style={{ paddingTop: '150px' }}>
          <LoadingSpinner text="Loading scheduled songs..." />
        </div>
      ) : (
        <>
          <div className="filterBox">
            <div className="innerFilterBox">
              <Dropdown
                open={filterDropDownOpen}
                destroyPopupOnHide
                overlay={filterDropDown}
                trigger={['click']}
                onOpenChange={bool => {
                  setFilterDropDownOpen(bool);
                  setPlaylistDropDownOpen(false);
                }}
                placement="bottomLeft"
                overlayClassName="filterDropDown"
                openClassName="filterDropDownMenu"
              >
                <button className={filterApplied ? 'active' : ''}>
                  <span
                    onClick={e => e.preventDefault()}
                    style={{
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Space>
                      <FilterIcon />
                    </Space>
                  </span>
                </button>
              </Dropdown>
              {filterApplied ? (
                <div className="filterTags">
                  {selectedPlayList
                    ? selectedPlayList.map((a, i) => {
                        return (
                          <div className="tag" key={i}>
                            <p>
                              <b>Playlist:</b>
                              {a}
                            </p>
                            <svg
                              onClick={() => {
                                setFilterPlayListId('');
                                setFilterPlayListName('Select playlist');
                                let playlistids = [...selectedPlayListIds];
                                if (playlistids.includes(playlistids[i])) {
                                  playlistids.splice(playlistids.indexOf(playlistids[i]), 1);
                                  // @ts-ignore
                                  setSelectedPlayListIds(playlistids);
                                  let playlist = [...selectedPlayList];
                                  playlist.splice(playlist.indexOf(playlist[i]), 1);
                                  setSelectedPlayList([...playlist]);
                                  getFuturelist(1, {
                                    playlsitId: playlistids,
                                    songUri: songUri,
                                    start_date: filterStartDate,
                                    end_date: filterEndDate,
                                  });
                                }
                              }}
                              width="8"
                              height="8"
                              viewBox="0 0 8 8"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M0.219247 0.21967C0.511575 -0.0732233 0.985534 -0.0732233 1.27786 0.21967L3.99229 2.93934L6.70672 0.21967C6.99905 -0.0732233 7.47301 -0.0732233 7.76534 0.21967C8.05766 0.512563 8.05766 0.987437 7.76534 1.28033L5.05091 4L7.76534 6.71967C8.05766 7.01256 8.05766 7.48744 7.76534 7.78033C7.47301 8.07322 6.99905 8.07322 6.70672 7.78033L3.99229 5.06066L1.27786 7.78033C0.985534 8.07322 0.511575 8.07322 0.219247 7.78033C-0.0730822 7.48744 -0.0730822 7.01256 0.219247 6.71967L2.93368 4L0.219247 1.28033C-0.0730822 0.987437 -0.0730822 0.512563 0.219247 0.21967Z"
                                fill="#007AFF"
                              />
                            </svg>
                          </div>
                        );
                      })
                    : null}
                  {songUri ? (
                    <div className="tag">
                      <p>
                        <b>URI/ URL:</b>
                        {songUri}
                      </p>
                      <svg
                        onClick={() => {
                          setSongUri('');
                          getFuturelist(1, {
                            playlsitId: selectedPlayListIds,
                            songUri: '',
                            start_date: filterStartDate,
                            end_date: filterEndDate,
                          });
                          if (
                            !filterPlayListId &&
                            !songUri &&
                            !filterStartDate &&
                            !filterEndDate &&
                            !selectedPlayList
                          ) {
                            setFilterApplied(false);
                          }
                        }}
                        width="8"
                        height="8"
                        viewBox="0 0 8 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0.219247 0.21967C0.511575 -0.0732233 0.985534 -0.0732233 1.27786 0.21967L3.99229 2.93934L6.70672 0.21967C6.99905 -0.0732233 7.47301 -0.0732233 7.76534 0.21967C8.05766 0.512563 8.05766 0.987437 7.76534 1.28033L5.05091 4L7.76534 6.71967C8.05766 7.01256 8.05766 7.48744 7.76534 7.78033C7.47301 8.07322 6.99905 8.07322 6.70672 7.78033L3.99229 5.06066L1.27786 7.78033C0.985534 8.07322 0.511575 8.07322 0.219247 7.78033C-0.0730822 7.48744 -0.0730822 7.01256 0.219247 6.71967L2.93368 4L0.219247 1.28033C-0.0730822 0.987437 -0.0730822 0.512563 0.219247 0.21967Z"
                          fill="#007AFF"
                        />
                      </svg>
                    </div>
                  ) : null}
                  {filterStartDate ? (
                    <div className="tag">
                      <p>
                        <b>Start Date:</b>
                        {dateFormate(filterStartDate)}
                      </p>
                      <svg
                        onClick={() => {
                          setFilterStartDate('');
                          getFuturelist(1, {
                            playlsitId: selectedPlayListIds,
                            songUri: songUri,
                            start_date: '',
                            end_date: filterEndDate,
                          });
                          if (
                            !filterPlayListId &&
                            !songUri &&
                            !filterStartDate &&
                            !filterEndDate &&
                            !selectedPlayList
                          ) {
                            setFilterApplied(false);
                          }
                        }}
                        width="8"
                        height="8"
                        viewBox="0 0 8 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0.219247 0.21967C0.511575 -0.0732233 0.985534 -0.0732233 1.27786 0.21967L3.99229 2.93934L6.70672 0.21967C6.99905 -0.0732233 7.47301 -0.0732233 7.76534 0.21967C8.05766 0.512563 8.05766 0.987437 7.76534 1.28033L5.05091 4L7.76534 6.71967C8.05766 7.01256 8.05766 7.48744 7.76534 7.78033C7.47301 8.07322 6.99905 8.07322 6.70672 7.78033L3.99229 5.06066L1.27786 7.78033C0.985534 8.07322 0.511575 8.07322 0.219247 7.78033C-0.0730822 7.48744 -0.0730822 7.01256 0.219247 6.71967L2.93368 4L0.219247 1.28033C-0.0730822 0.987437 -0.0730822 0.512563 0.219247 0.21967Z"
                          fill="#007AFF"
                        />
                      </svg>
                    </div>
                  ) : null}
                  {filterEndDate ? (
                    <div className="tag">
                      <p>
                        <b>End Date:</b>
                        {dateFormate(filterEndDate)}
                      </p>
                      <svg
                        onClick={() => {
                          setFilterEndDate('');
                          getFuturelist(1, {
                            playlsitId: selectedPlayListIds,
                            songUri: songUri,
                            start_date: filterStartDate,
                            end_date: '',
                          });
                          if (
                            !filterPlayListId &&
                            !songUri &&
                            !filterStartDate &&
                            !filterEndDate &&
                            !selectedPlayList
                          ) {
                            setFilterApplied(false);
                          }
                        }}
                        width="8"
                        height="8"
                        viewBox="0 0 8 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M0.219247 0.21967C0.511575 -0.0732233 0.985534 -0.0732233 1.27786 0.21967L3.99229 2.93934L6.70672 0.21967C6.99905 -0.0732233 7.47301 -0.0732233 7.76534 0.21967C8.05766 0.512563 8.05766 0.987437 7.76534 1.28033L5.05091 4L7.76534 6.71967C8.05766 7.01256 8.05766 7.48744 7.76534 7.78033C7.47301 8.07322 6.99905 8.07322 6.70672 7.78033L3.99229 5.06066L1.27786 7.78033C0.985534 8.07322 0.511575 8.07322 0.219247 7.78033C-0.0730822 7.48744 -0.0730822 7.01256 0.219247 6.71967L2.93368 4L0.219247 1.28033C-0.0730822 0.987437 -0.0730822 0.512563 0.219247 0.21967Z"
                          fill="#007AFF"
                        />
                      </svg>
                    </div>
                  ) : null}
                </div>
              ) : null}
            </div>
          </div>
          {Array.isArray(paginatedData) && paginatedData.length ? (
            <ScheduledPlaylistSongTable
              menu={menu}
              scheduleData={scheduleData}
              playlistState={playlistState}
              totalPlaylist={totalPlaylist}
              bulkAction={bulkAction}
              selectSongFunction={selectSongFunction}
              currentPage={pageState}
              selectedSongs={selectedSongs}
              setBulkAction={setBulkAction}
              selectMultpleSongFunction={selectMultpleSongFunction}
              selectSingleSong={selectSingleSong}
              selectedIndex={selectedIndex}
              setSelectedIndex={setSelectedIndex}
            />
          ) : (
            <p style={{ color: '#ffffffa3', textAlign: 'center' }}>There is no relevant data</p>
          )}
        </>
      )}

      {blurBackground ? <div className="blurrScreen"></div> : null}
      <AddToPlayListModal
        isModalVisible={addToPlaylistModal}
        setIsModalVisible={setAddToPlaylistModal}
        hideRadioButtons={true}
        preRelease={true}
        existSongUri={existSongUri}
        getFuturelist={getFuturelist}
        editObj={editObj}
        hideArtistAndSongName={false}
      />

      <EditAddToPlayListModal
        isModalVisible={EditaddToPlaylistModal}
        setIsModalVisible={setEditAddToPlaylistModal}
        editType={editType}
        setEditType={setEditType}
        editId={EditId}
        preRelease={true}
        ViewDetailData={{
          ...data,
          // @ts-ignore
          endTime: data?.end_time || data?.localData?.end_time,
          // @ts-ignore
          songUri: data?.song_uri || data?.uri,
          // @ts-ignore
          notes: data?.notes || data?.localData?.notes,
          _id: EditId,
        }}
        loadingText="Loading scheduled tracks"
        loadingTextHead="Loading playlist"
        onEndDateSuccess={updateSongEndDate}
        onNotesSuccess={updateSongNotes}
      />
      <ShareModal
        isModalVisible={shareSongModal}
        setIsModalVisible={setShareSongModal}
        editType={'viewDetail'}
        ViewDetailData={data}
        setViewDetailData={setData}
        currentPlaylistData={
          Array.isArray(playlistState?.playlists)
            ? (totalPlaylist.length > 0 ? totalPlaylist : playlistState.playlists).find(item => {
                if (data) {
                  // @ts-ignore
                  // Check both localData and root level for playlist ID
                  const playlistId = data?.localData?.selected_playlist_id || data?.selected_playlist_id;
                  if (playlistId) {
                    // @ts-ignore
                    return item?.id === playlistId;
                  }
                }
                return false;
              })
            : undefined
        }
        // @ts-ignore
        PlaylistRefreshRecord={PlaylistRefreshRecord}
        showCopyUrl={true}
        scheduleSong={true}
      />
      <ShareModalLoader
        isModalVisible={shareSongLoaderModal}
        setIsModalVisible={setShareSongLoaderModal}
      />
      <InstantShareModal
        isModalVisible={instantShareSongModal}
        setIsModalVisible={setInstantShareSongModal}
        editType={'viewDetail'}
        titleType="scheduled"
      />
      <DeleteModal
        handleCancel={handleCancelDelete}
        showModal={showModalDelete}
        isModalOpen={isModalOpenDelete}
        handleOk={handleOkDelete}
        heading={'Delete from playlist'}
        headingText={'Are you sure you want to delete this song?'}
        button1={'Delete'}
        button2={'Cancel'}
      />
      <DeleteModal
        handleCancel={handleCancelDeleteSelected}
        showModal={showModalDeleteSelected}
        isModalOpen={isModalOpenDeleteSelected}
        handleOk={handleOkDeleteSelected}
        heading={`Delete ${selectedSongs.length} song(s) from playlist`}
        headingText={`Are you sure you want to delete these songs?`}
        rememberCheckbox={true}
        // @ts-ignore
        positionWarning={''}
        button1={'Delete & Refresh'}
        button2={'Cancel'}
      />
    </PlaylistStyle>
  );
};

export default ScheduledTracks;
